import { noop } from 'lodash-es';
import type { ReactNode } from 'react';
import { createContext, useState } from 'react';

type Props = {
    children: ReactNode;
};

const context = createContext({
    errorMessage: '',
    updateErrorMessage: noop,
});

/* eslint-disable react-refresh/only-export-components */
export function getErrorContext() {
    return context;
}

export default function ErrorProvider({ children }: Props) {
    const [errorMessage, setErrorMessage] = useState('');
    const ErrorContext = getErrorContext();

    const updateErrorMessage = (message: string): void => {
        setErrorMessage(message);
    };

    const providerValue = {
        errorMessage,
        updateErrorMessage,
    };

    return <ErrorContext.Provider value={providerValue}>{children}</ErrorContext.Provider>;
}
